// extracted by mini-css-extract-plugin
export default {"popupRecord":"styles_popupRecord__RPCFI"};